export default theme => ({
  logoLink: {
    display: 'flex',
    alignItems: 'center',
  },
  logoImage: {
    maxWidth: '100%',
    [theme.breakpoints.only('xs')]: {
      // maxWidth: '100%'
    }
  }
});